import "../styles/about.css";
import imgMena from "../imges/mena.jpg"
export default function About() {
    return <>
        <section className="About">
      <h2 id="About">About me</h2>
      <div className="container-About">
        <div className="text-About">
          <div className="name">
            <h1>
              Mena
            </h1>
            <h1>mazher</h1>
          </div>
          <div className="description-About">
            <h4 >
              My name is Beto , I am from Luxor, I am 20 years old, 7 years of
              experience in the field of photography
            </h4>
          </div>
        </div>
        <div className="img-About">
          <img src={ imgMena } alt="beto" />
        </div>
      </div>
    </section>
    </>;
};